import React, { createContext, useContext, useState, useMemo } from 'react';


const AssistantChatContext = createContext();


export const useAssistantChat = () => {
	const context = useContext(AssistantChatContext);
	if (!context) {
		throw new Error('useAssistantChat must be used within an AssistantChatProvider');
	}
	return context;
};


export const AssistantChatProvider = ({ children }) => {
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);
	const [isMinimized, setIsMinimized] = useState(false);
	const [isFullscreen, setIsFullscreen] = useState(false);

	// Simplified value object - only create new object when state actually changes
	const value = useMemo(() => ({
		isSidebarOpen,
		isMinimized,
		isFullscreen,
		openSidebar: () => {
			setIsSidebarOpen(true);
			setIsMinimized(false);
			setIsFullscreen(false);
		},
		closeSidebar: () => {
			setIsSidebarOpen(false);
			setIsMinimized(false);
			setIsFullscreen(false);
		},
		minimizeSidebar: () => {
			setIsMinimized(true);
			setIsFullscreen(false);
		},
		maximizeSidebar: () => {
			setIsMinimized(false);
			setIsFullscreen(false);
		},
		fullscreenSidebar: () => {
			setIsFullscreen(true);
			setIsMinimized(false);
			setIsSidebarOpen(true);
		},
		exitFullscreen: () => {
			setIsFullscreen(false);
		}
	}), [isSidebarOpen, isMinimized, isFullscreen]);

	return (
		<AssistantChatContext.Provider value={value}>
			{children}
		</AssistantChatContext.Provider>
	);
};

export default AssistantChatContext;
